/** Debe coincidir con HISTORIAL_CAMBIOS_MAX en functions/src/audit/historial.ts */
export const HISTORIAL_STORE_MAX = 40;

/** Entradas visibles al abrir el diálogo de historial */
export const HISTORIAL_UI_INITIAL = 5;

/** Cuántas entradas más antiguas se muestran al pulsar "Ver más" */
export const HISTORIAL_UI_PAGE_SIZE = 5;

export function nextHistorialVisibleCount(current: number, total: number): number {
  return Math.min(current + HISTORIAL_UI_PAGE_SIZE, total);
}

export function historialHasMore(visibleCount: number, total: number): boolean {
  return visibleCount < total;
}
